<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12" v-if="is_admin === true">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Choose Company</span>
            <small></small>
          </div>
          <div class="card-body">
            <b-row>
              <b-col sm="4">
                <b-form-group>
                  <label for="Company List"> Company List </label><br />
                  <model-list-select
                    :list="companylist"
                    option-value="company_id"
                    option-text="company_name"
                    v-model="selectcompany"
                    placeholder="Search Company Name"
                    @searchchange="searchcompany($event)"
                    @input="onSelectCompnay($event)"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 30px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 30px;
                      border-radius: 1px;
                      padding-top: 6px;
                    "
                    class="product-drop"
                  ></model-list-select>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div slot="header">
              <div class="row">
                <div class="col-sm-9">
                  <i style="color: #20a8d8;"></i>List Purchase Return Payment
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;
                <!-- <div class="col-sm-1">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary label_bttn"
                    @click.prevent="exportData()"
                  >
                    <i class=""></i> Export Data
                  </button>
                </div> -->
              </div>
            </div>
          </div>
          <div class="card-body">
            <vue-good-table
              :columns="columns"
              :rows="rows"
              mode="remote"
              ref="my-table"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :pagination-options="{ enabled: true, perPage: 5 }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                <span>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
export default {
  name: "ListSalePayment",
  components: {
    "date-picker": DatePicker,
    Spinner,
  },
  data() {
    return {
      companylist: [],
      selectcompany: null,
      loading: false,
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          // field: 'purchase_id',
          // type: 'asc',
        },
        page: 1,
        perPage: 5,
      },
      columns: [
        {
          label: "Payment Id",
          field: "payment_id",
          width: "15% !important",
        },
        {
          label: "Purchase Return Id",
          field: "purchase_return_id",
          width: "15% !important",
        },
        {
          label: "Purchase Id",
          field: "purchase_id",
          width: "15% !important",
        },
        {
          label: "Shop",
          field: "est_shop_name",
          width: "15% !important",
        },
        {
          label: "Supplier",
          field: "sup_cmp_name",
          width: "20% !important",
        },
        {
          label: "Payment Mode",
          field: "payment_mode",
          width: "10% !important",
        },
        {
          label: "Amount",
          field: "amount",
          width: "10% !important",
        },
        {
          label: "Cheque No",
          field: "cheque_no",
          width: "15% !important",
        },
      ],
    };
  },
  computed: {
    is_admin: function () {
      if (this.$store.getters.get_is_admin) {
        return true;
      } else {
        this.PurPayment();
        this.shopuser();
        return this.$store.getters.get_is_admin;
      }
    },
  },
  // created(){
  //   this.PurPayment();
  //   this.shopuser();
  // },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.PurPayment();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.PurPayment();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.PurPayment();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.PurPayment();
    },
    shopuser() {
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },
    searchcompany(searchText) {
      var _this = this;
      this.$http
        .get(
          "/api/companies?filter[where][company_name][ilike]=%" +
            searchText +
            "%"
        )
        .then(function (response) {
          // console.log(response)
          _this.companylist = response.data;
        })
        .catch(function (error) {});
    },
    onSelectCompnay(selectedcompany) {
      this.PurPayment();
    },
    PurPayment() {
      var _this = this;
      this.loading = true;
      let filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var data = "";
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][user_id]=" +
          this.selectcompany.cmp_email +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      this.$http
        .get(
          "/api/inventorypurchasereturns/prchsrtsPaymentHistory?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows = response.data;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          _this.loading = false;
        });
    },

    //Nishith Changes For Excel Report
    exportData() {
      // alert('data')
      var _this = this;
      this.$http
        .get("/api/inventorypurchasereturn/getPurchaseHistoryExport")
        .then(function (response) {
          // console.log(response)

          //  alert('isslke paas')
          var access_token = localStorage.getItem("authUser");
          // console.log(response.data)
          var url1 =
            _this.baseURL2 +
            "/api/containers/csv/download/" +
            response.data +
            "?access_token=" +
            access_token;
          // console.log('url  '  + url1)
          // var url1 = '/api/containers/csv/download/1593025721009.csv';
          _this
            .$http({
              url: url1,
              method: "GET",
              responseType: "blob",
            })
            .then((res) => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.setAttribute("download", response.data);
              link.href = url1;
              document.body.appendChild(link);
              link.click();
            })
            .catch(function (er) {
              console.log(er);
              _this.loading = false;
            });
          ///End OF Exce Downlod Method...
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/purches/PurchaseReturnpayment.vue